// Account endpoints. POST was CLI-only in B.1 (see spec §3.1);
// B.1.5 promoted creation to the UI and added the matching backend
// endpoint, so the form lives in features/accounts/AccountCreateForm.

import { request, type ApiResponse } from "../client";
import type { AccountCreate, AccountOut } from "../types/account";

export const accounts = {
  list: (): Promise<ApiResponse<AccountOut[]>> =>
    request<AccountOut[]>("GET", "/api/v1/accounts"),

  get: (accountSlug: string): Promise<ApiResponse<AccountOut>> =>
    request<AccountOut>("GET", `/api/v1/accounts/${encodeURIComponent(accountSlug)}`),

  create: (body: AccountCreate): Promise<ApiResponse<AccountOut>> =>
    request<AccountOut>("POST", "/api/v1/accounts", body),
};
